<template>
  <div>
    <p
      :class="{'text-nowrap': wrapText}"
      class="ds-text-xs md:ds-text-sm font-medium text-gray-900 my-auto"
      v-html="value ? value : '–'"
    ></p>
    <p class="ds-text-2xs md:ds-text-2xs font-bold text-gray-500 uppercase text-nowrap">{{ label }}</p>
  </div>
</template>

<script>
export default {
  name: "AthleteStat",
  props: {
    value: {
      type: String | Boolean,
      default: "–",
    },
    label: {
      type: String,
      required: true,
    },
  },
  computed: {
    wrapText() {
      return this.value?.length <= 25;
    },
  }
}
</script>
<style scoped>
.text-nowrap {
  white-space: nowrap;
}
</style>